export const environment = {
  defaultValue: {
    activeMinimal: false,
    language: '',
    domain: '',
    sessionToken: '',
    token: '',
    userCode: '',
    clientCode: '',
    clientId: '',
    portfolioId: '',
    portfolioCode: '',
    apiKey: '',
    formatsTech:
      '[",",".",",",2,"€","s", "R","R","U",0,-10000,"-","+","L", "%","DD/MM/YYYY"]',
    conditionalFormats:
      '[{"AssetTypes":"3,7,8,A,Á,AR,B,BSE,BSU,C,D,DB,E,È,É,F,FI,G,H,I,Í,M,N,O,Ó,OT,P,PE,Q,R,RE,S,SIC,T,U,Ú,V,W,X,Z,","Currencies":"AED,ARS,AUD,BGN,BMD,BRL,BSD,CAD,CHF,CLF,CLP,CNH,CNY,CRC,CZK,DKK,EEK,EGP,EUR,GBP,HKD,HRK,HUF,IDR,ILS,INR,ISK,JPY,KES,KRW,KZD,LTL,LVL,MAD,MXN,MYR,NOK,NZD,PAB,PEN,PLN,ROL,RUB,SAR,SEK,SGD,SKK,THB,TRL,TRY,TWD,UAH,UND,USc,USD,ZAR,","PriceDecimalNumber":2,"PricePattern":"#,0.00","ValuationDecimalNumber":2,"ValuationPattern":"#,0.00"}]',
    GroupSeparator: '.',
    DateFormat: 'DD/MMM/YYYY',
    DecimalSeparator: ',',
    NEGATIVE_SYMBOL: '-',
    NUMBER_OF_DECIMAL: 2,
  },
};
